import SeoContext from '../../lib/seo-context';
import { fetchAPI } from '../../lib/api';
import Image from 'next/image';
import Layout from '../../components/layout';
import HeroSubpage from '../../components/hero-subpage';
import PhotoGallery from '../../components/photo-gallery';
import { Merge } from '../../lib/helper';
import Link from 'next/link';
import { useGlobalContext } from '../../lib/global-context';
const Event = (props) => {
    const { state } = useGlobalContext();
    const { pageProps, global } = props;
    if (!pageProps) {
        return '';
    }

    const seo = Merge(global?.seo, pageProps?.seo);
    seo.canonicalURL = `${process.env.NEXT_PUBLIC_SITE_URL}/news/${pageProps.slug}`;

    return (
        <SeoContext.Provider value={seo}>
            <Layout
                languageData={{ originalSlug: pageProps.originalSlug, languages: pageProps.localizations }}
            >
                <section>
                    <HeroSubpage content={`<h1>${pageProps.title}</h1>`}></HeroSubpage>
                    <article className={state.galleryStatus ? `` : `z-20 relative`}>
                        <div className="container p-10 pt-0">
                            <div className="flex flex-col md:flex-row">
                                <div className="flex flex-col pr-0 lg:pr-8">
                                    <div className="relative w-full rounded-lg overflow-hidden">
                                        {pageProps.gallery.data > 0 &&
                                            <PhotoGallery
                                                layout="fill"
                                                className={`cols-1`}
                                                photos={{ data: [pageProps.gallery.data[0]] }}
                                            ></PhotoGallery>
                                        }
                                    </div>


                                    <div className='mt-2'>
                                        <div className=" bg-maturity-100 px-2 py-1 text-xs rounded-md inline-block">
                                            {new Date(pageProps.date).toDateString()}
                                        </div>
                                    </div>

                                    <div
                                        className="pt-2"
                                        dangerouslySetInnerHTML={{ __html: pageProps.content }}
                                    ></div>


                                    <div className="py-10">
                                        <Link href="/news">
                                            <a className="btn maturity-border">Back to news</a>
                                        </Link>
                                    </div>
                                </div>
                                <div
                                    className={`flex flex-col flex-wrap flex-shrink-0  basis-1 lg:basis-1/3 `}
                                >
                                    {pageProps.gallery.data && (
                                        <PhotoGallery
                                            layout="fill"
                                            className={`cols-${pageProps.gallery.data.length > 2 ? 2 : 1}`}
                                            photos={{ data: pageProps.gallery.data.slice(1) }}
                                        ></PhotoGallery>
                                    )}
                                </div>
                            </div>
                        </div>
                    </article>
                </section>
            </Layout>
        </SeoContext.Provider>
    );
};

export async function getStaticPaths({ locale }) {
    const eventRes = await fetchAPI('/news-insights', {
        sort: ['date:desc'],
        locale,
        populate: 'deep,1'
    });

    return {
        paths: eventRes.data.map((p) => ({
            params: {
                slug: p.attributes.slug
            },
            locale
        })),
        fallback: true
    };
}

export async function getStaticProps({ params, locale }) {
    const result = await fetchAPI(`/news-insights/by-slug/${params.slug}`, {
        populate: 'deep,3',
        locale
    });

    return {
        props: { pageProps: result.data.attributes },
        revalidate: Number(process.env.NEXT_PUBLIC_PAGE_REVALIDATION) || 100
    };
}

export default Event;
